module.exports = __webpack_public_path__ + "static/img/05_trust.6d14f9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/05_trust.png
// module id = D8f1
// module chunks = 158